import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogLookupUsersGroupsComponent } from '../../../../../shared/components/dialog-lookup-users-groups/dialog-lookup-users-groups.component';
import { PERMISSIONS } from '../../../../../../../environments/environment';
import { SearchService } from '../../../../../search/shared/services/search.service';
import { FormControl } from '@angular/forms';

export interface IOtherInfo {
  info: string;
  control: FormControl;
  controlPlaceholder?: string;
  isRequired: boolean;
}

@Component({
  selector: 'app-dialog-lookup-permissions',
  templateUrl: './dialog-lookup-permissions.component.html',
  styleUrls: ['./dialog-lookup-permissions.component.scss']
})
export class DialogLookupPermissionsComponent implements OnInit {
  public loading: boolean;
  public results: any[];
  public search: string;
  public listElementsChecked: any[];
  public configuredPermissions: any[];

  constructor(
    public dialogRef: MatDialogRef<DialogLookupUsersGroupsComponent>,
    private searchService: SearchService,
    @Inject(MAT_DIALOG_DATA) public data: { onlyUsers?: boolean; hidePermissions?: boolean, askOtherInfo: IOtherInfo }
  ) { }

  ngOnInit() {
    this.loading = false;
    this.listElementsChecked = [];
    this.configuredPermissions = [];

    for (const perm in PERMISSIONS) {
      if (PERMISSIONS[perm]) {
        this.configuredPermissions.push(PERMISSIONS[perm]);
      }
    }
  }

  public onConfirm() {
    this.dialogRef.close(this.listElementsChecked);
  }

  public searchGroupOrUser(search) {
    
    this.loading = true;

    let req = null;

    if (this.data?.onlyUsers) {
      req = this.searchService.searchUser(search);
    } else {
      req = this.searchService.searchGroupAndUser(search);
    }

    req.then(res => {
      if(search.length > 0) {
        this.results = res.list.entries.map(e => e.entry);
        
  
        this.results.forEach((el, index) => {
          el.role = 'SiteCollaborator';
  
          const indexIfAdded = this.hasAlreadyBeenAdded(
            el,
            this.listElementsChecked
          );
          if (indexIfAdded !== -1) {
            // el.isChecked = true;
            // el.isChecked = this.listElementsChecked[indexIfAdded].role;
            // this.listElementsChecked[indexIfAdded] = el;
            this.results[index] = this.listElementsChecked[indexIfAdded];
          }
        });
      } else {
        this.results = [];
      }
      
    })
      .finally(() => (this.loading = false));
  }

  public updateCheckArray() {
    this.results.forEach(el => {
      if (
        el.isChecked &&
        this.hasAlreadyBeenAdded(el, this.listElementsChecked) === -1
      ) {
        this.listElementsChecked.push(el);
      }
    });

    this.listElementsChecked = this.listElementsChecked.filter(
      el => el.isChecked
    );
  }

  public hasAlreadyBeenAdded(el, arr) {
    let i = 0;
    for (const r of arr) {
      if (r.id === el.id) {
        return i;
      }

      i++;
    }

    return -1;
  }
}
